/**
 * Compares current price with historical snapshot
 *
 * Price change formula
 * https://www.investopedia.com/terms/p/percentage-change.asp
 * increase = updated - original
 * increase % = (increase / original) * 100
 */

import { ITicker } from '@kattana-io/common';
import useTicker from '../hooks/useTicker';

export interface IPriceChange {
  priceChange: number;
  priceChangePercent: number;
}

const calculateYesterdayPrice = (
  currentPriceUSD: number,
  priceDiffPercent: number
) => {
  // check for zero
  if (1 + priceDiffPercent / 100 === 0) {
    return 0;
  }

  const yesterdayPriceUSD = currentPriceUSD / (1 + priceDiffPercent / 100);

  return yesterdayPriceUSD;
};

const getPriceChange = (
  currentPriceUSD: number,
  ticker?: ITicker
): IPriceChange => {
  if (!ticker) {
    return {
      priceChange: 0,
      priceChangePercent: 0,
    };
  }

  const { price_usd, change_usd } = useTicker(ticker);
  const yesterdayPriceUSD = calculateYesterdayPrice(price_usd, change_usd);

  const priceDiff = yesterdayPriceUSD ? currentPriceUSD - yesterdayPriceUSD : 0;
  const priceDiffPer = yesterdayPriceUSD
    ? (priceDiff / yesterdayPriceUSD) * 100
    : 0;

  return {
    priceChange: priceDiff,
    priceChangePercent: priceDiffPer,
  };
};

export { getPriceChange };
